import StackedBarChart from './WeeklyStackedBarChart';

export default StackedBarChart;
